import { STypeGrpIds } from './sTypeGrpIds';

export const sTypeGrpIdIsFund = (sTypeGrpId: string | number | null) => {
  const sTypeGrpIdNumber = typeof sTypeGrpId === 'string' ? parseInt(sTypeGrpId, 10) : sTypeGrpId;
  if (sTypeGrpIdNumber == null) {
    return false;
  }
  return sTypeGrpIdNumber === STypeGrpIds.FONDS;
};
